import ConfirmToast from './pages2/confirmToast';
import SettingModal from './pages2/settingLayer';
import { namespace } from '@ncui-util-common/util';

/**
 * confirmToast
 */
namespace('ncui.util.globalCookieSetting.confirmToast');
window.ncui.util.globalCookieSetting.ConfirmToast = ConfirmToast;

function confirmToast({zIndex}: {zIndex?: number} = {}){
  return new ConfirmToast({zIndex});
}

/**
 * settingModal
 */
namespace('ncui.util.globalCookieSetting.settingModal');
window.ncui.util.globalCookieSetting.SettingModal = SettingModal;

function settingModal({zIndex}: {zIndex?: number} = {} ){
  return new SettingModal({zIndex});
}
